import { useSearchParams } from "react-router-dom";
import PhysicalAndMentalSymptomService from "../../../services/PhysicalAndMentalSymptomService";
import { useEffect, useState } from "react";
import { PhysicalAndMentalSymptom } from "../../../models";
import Breadcrumbs from "../../../components/breadcrumbs";
import toast from "react-hot-toast";
import { CreateButton } from "./ui/buttons";
import SymptomsTable from "./ui/symptoms-table";
import SymptomsTableSkeleton from "./skeletons/symptoms-table-skeleton";

export default function PhysicalAndMentalSymptomsPage(){
    const [searchParams] = useSearchParams();
      const api = new PhysicalAndMentalSymptomService();
      const [items, setItems] = useState<PhysicalAndMentalSymptom[]>([]);
      const [loading, setLoading] = useState(true);
    
      useEffect(() => {
        fetchData();
      }, [searchParams.get("reload")]);
    
      const fetchData = async () => {
        try{
        const data = await api.getSymptoms();
        setItems(data);
    }
    catch(e){
        console.log(e);
        toast.error("Data load error");
    }
    setLoading(false);
      };
    
      return (
        <div className="w-full">
             <Breadcrumbs
                        breadcrumbs={[
                          { label: "Physical & Mental Symptoms", href: "/admin/physical-and-mental-symptoms" },                      
                        ]}
                      />
          <CreateButton />
          {loading ? (
            <SymptomsTableSkeleton />
          ) : (
            <SymptomsTable items={items} />
          )}
        </div>
      );
    }
